export enum BranchServicesOrBranchCategories {
  BranchServices = 1,
  BranchCategories = 2
}
